// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3ZPgw","tab":"Tabs_tab__2a00L","tabActive":"Tabs_tabActive__3Q5Tj"};